<template>
  <div class="headquarter-external-transaction-tab">
    <ExternalTransactionRecordTable
      v-loading="loading.table"
      :tableData="tableData"
      :enable-columns="['shopName']"
      :externalData="{ shopList }"
      :fetch-transactions-api="GetHeadquarterExternalTransaction"
      :find-record-api="FindHeadquarterExternalTransaction"
      :options="{
        showBranch: false,
        showPhone: false,
      }"
      @refresh="refresh(false)"
    />
    <Pagination
      :curPage.sync="tableOptions.page"
      :pageLimit="tableOptions.pageLimit"
      :total="tableDataCount"
      @pageChange="refresh(false)"
    />
  </div>
</template>

<script>
import { get } from 'lodash'
import { onMounted, onActivated, onBeforeMount, defineComponent, ref } from 'vue'
import { useTable } from '@/use/table'
import {
  GetHeadquarterExternalTransaction,
  GetHeadquarterExternalTransactionCount,
  FindHeadquarterExternalTransaction,
} from '@/api/memberExternalTransaction'
import ExternalTransactionRecordTable from '@/components/ExternalTransaction/ExternalTransactionRecordTable.vue'
import { useFetch } from '@/use/fetch'
import { GetShops } from '@/api/shop'
import { apiFormatAdaptor } from '@/utils/api'

export default defineComponent({
  name: 'HeadquarterExternalTransactionTab',
  components: {
    ExternalTransactionRecordTable,
  },
  props: ['member'],
  setup (props) {
    const {
      tableData,
      tableOptions,
      tableDataCount,
      loading,
      pageStartIndex,
      shopId,
      fetchData,
      fetchDataCount,
    } = useTable()
    const { fetchAll } = useFetch()
    const shopList = ref([])

    onBeforeMount(async () => {
      fetchAll(apiFormatAdaptor(GetShops), null, (res) => {
        shopList.value = res
      })
    })

    const getTableData = async () => {
      const payload = {
        MemberId: get(props.member, 'id', undefined),
        shopId: shopId.value,
        start: pageStartIndex.value,
        limit: tableOptions.pageLimit,
      }
      await Promise.allSettled([
        fetchData(GetHeadquarterExternalTransaction, payload),
        fetchDataCount(GetHeadquarterExternalTransactionCount, payload),
      ])
    }

    const refresh = async (search = false) => {
      if (search) tableOptions.page = 1
      loading.table = true
      await getTableData()
      loading.table = false
    }

    onMounted(async () => {
      await refresh()
    })
    onActivated(async () => {
      await refresh()
    })

    return {
      tableData,
      tableOptions,
      tableDataCount,
      loading,
      shopList,
      GetHeadquarterExternalTransaction,
      FindHeadquarterExternalTransaction,
      refresh,
    }
  },
})
</script>

<style scoped lang="scss">
</style>
